import React from 'react';
import {
  PageHeaderWrapper,
  PageHeaderOverlay,
  PageHeaderInner,
  PageHeaderTitle,
  PageHeaderSubtitle,
} from '../styles/PageHeaderStyles';

const PageHeader = ({ title, subtitle, image }) => {
  const backgroundUrl =
    image && image.data && image.contentType
      ? `data:${image.contentType};base64,${image.data}`
      : null;

  return (
    <PageHeaderWrapper
      style={backgroundUrl ? { backgroundImage: `url(${backgroundUrl})` } : undefined}
    >
      <PageHeaderOverlay />
      <PageHeaderInner>
        {title && <PageHeaderTitle>{title}</PageHeaderTitle>}
        {subtitle && <PageHeaderSubtitle>{subtitle}</PageHeaderSubtitle>}
      </PageHeaderInner>
    </PageHeaderWrapper>
  );
};

export default PageHeader;
